// extracted by mini-css-extract-plugin
export default {"price":"ServiceTable_price__EOwB4","price-col":"ServiceTable_price-col__0FnB3","theme-grayscale":"ServiceTable_theme-grayscale__pyuYl"};